import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { ButtonGroup, TextContainer, Button } from '@superops/ui-design-system';
import { Delete } from '@styled-icons/material/Delete';
import { injectIntl } from 'react-intl';
import { B1, CustomModal, H2, getTranslatedText } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const DeleteIcon = styled(Delete)`
  height: 20px;
  color: black;
  width: 20px;
`;

const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 20px;
  margin: auto;
  min-width: 600px;
  max-width: 60rem;
  max-height: calc(100vh - 60px);

  & > div {
    padding: 20px;
  }
  .header {
    border-bottom: 1px solid #f2f2f2;
  }
  .footer {
    padding: 16px;
    // border-top: 1px solid #F2F2F2;
    position: static;

    .Superops-ButtonGroup {
      justify-content: flex-end;
    }
  }
`;

function CustomConfirmationModal(props) {
  const [active, setActive] = useState(false);
  const {
    intl,
    modalActivator,
    confirmText,
    validateForm,
    confirmationLoading
  } = props;
  const handleChange = useCallback(() => setActive(!active), [active]);

  const handleConfirmation = useCallback(() => {
    if (validateForm && validateForm()) {
      return;
    }
    if (props.handleConfirmation) {
      props.handleConfirmation(handleChange);
    }
  });

  return (
    <div>
      {modalActivator ? (
        <div onClick={handleChange} id={props.id}>
          {modalActivator}
        </div>
      ) : (
        <Button
          onClick={handleChange}
          id={props.id}
          destructive={props?.destructive}
          plain={props?.plain}
        >
          {props?.noIcon ? 'Delete' : <DeleteIcon />}
        </Button>
      )}
      <CustomModal
        open={active}
        onClose={handleChange}
        title={props.title || 'Confirmation'}
        primaryAction={{
          content: confirmText || getTranslatedText(intl, 'common.confirm'),
          onAction: handleConfirmation
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'common.cancel'),
            onAction: handleChange,
            plainSecondary: true
          }
        ]}
        zIndex={props?.zIndex}
      >
        <ModalContainer>
          <div className="header fx actr">
            <H2>
              <B1>{props.title || 'Confirmation'}</B1>
            </H2>
          </div>
          <TextContainer>
            {props.template ? (
              props.template
            ) : (
              <p>{props.description || 'Are you sure?'}</p>
            )}
          </TextContainer>
          <div className="footer">
            <ButtonGroup spacing="loose">
              <Button plainSecondary onClick={handleChange}>
                {getTranslatedText(intl, 'common.cancel')}
              </Button>
              <Button
                primary
                onClick={handleConfirmation}
                loading={confirmationLoading}
              >
                {getTranslatedText(intl, 'common.confirm')}
              </Button>
            </ButtonGroup>
          </div>
        </ModalContainer>
      </CustomModal>
    </div>
  );
}

export default injectIntl(CustomConfirmationModal);
